import { render, staticRenderFns } from "./importDownload.vue?vue&type=template&id=71f37120&scoped=true"
import script from "./importDownload.vue?vue&type=script&lang=js"
export * from "./importDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f37120",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71f37120')) {
      api.createRecord('71f37120', component.options)
    } else {
      api.reload('71f37120', component.options)
    }
    module.hot.accept("./importDownload.vue?vue&type=template&id=71f37120&scoped=true", function () {
      api.rerender('71f37120', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/cope/routeDistanceReference/cmp/importDownload.vue"
export default component.exports